<app-card label="SIT Survey">
    You do not have a Symptom Inventory Survey due at this time. If you feel this is incorrect, please contact your Care Team for assistance.
</app-card>
<router-outlet></router-outlet>